import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "eyeFocus",
    iconColor: "white",
    text: "Measure, monitor and \npivot the marketing \nstrategy in real time",
    listItemCustomStyle: { width: "282px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithGraphics",
    iconColor: "white",
    text: "Over 50% increase in \nreach with AI infused \npersonalization",
    listItemCustomStyle: { width: "283px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "boxWithDiscInsideAndClock",
    iconColor: "white",
    text: "Overtime 90% increase \nin first party data \nharnessing",
    listItemCustomStyle: { width: "282px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "graphWithMagnificationAndGear",
    iconColor: "white",
    text: "Over 40% reduction in \nnon-working capital \nspend on marketing",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_AI_TWIN_1 = {
  styleLeftPanel: {
    paddingRight: 0,
    paddingTop: "54px",
    paddingBottom: "51px",
    borderRadius: "0px 300px 15px 0px",
    minWidth: "1380px",
    minHeight: "845px",
  },
  title: "AI-TWIN for marketers",
  text: "Your AI partner that transforms marketing with autonomous\nrecommendations, visibility, decisioning, and activation to inspire, engage,\nand delight consumers in real time.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage(302),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(1),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_01.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
};
